import { defineStore } from 'pinia';

type WeightUnit = { shortDescription: string; mediumDescription: string };
export type WeightUnits = Record<number, WeightUnit>;

export const useWeights = defineStore('weights', {
  state: () => ({
    units: {
      0: {
        shortDescription: 'kg',
        mediumDescription: 'kg',
      },
      1: {
        shortDescription: 'g',
        mediumDescription: 'g (gram)',
      },
      2: {
        shortDescription: 'lbs',
        mediumDescription: 'lbs',
      },
    } as WeightUnits,
  }),

  getters: {
    unitKeys: (state) => {
      return Object.keys(state.units).map((key) => parseInt(key));
    },

    unitSuffix: (state) => {
      return (unitId: number | null | undefined) => {
        if (unitId == null) return '';
        return state.units[unitId]?.shortDescription ?? '';
      };
    },
  },
});
